import type { GatorProtectProBillingCycle } from '../../hooks/useGatorProtectProPlan';
import type {
  UpgradeCycleModalOption,
  UpgradeCycleModalProps,
} from './UpgradeCycleModal.types';

const DEFAULT_CONFIRM_CYCLE: GatorProtectProBillingCycle = 'monthly';

export function getCycleKeyForCopy(
  selectedOption: UpgradeCycleModalOption | undefined,
  upgradeCycleOptions: UpgradeCycleModalOption[],
): GatorProtectProBillingCycle {
  if (selectedOption != null) {
    return selectedOption.cycleKey;
  }
  const firstOption = upgradeCycleOptions[0];
  if (firstOption != null) {
    return firstOption.cycleKey;
  }
  return DEFAULT_CONFIRM_CYCLE;
}

export function getDiscountForHero(selectedOption: UpgradeCycleModalOption | undefined): number {
  if (selectedOption == null) {
    return 0;
  }
  return selectedOption.discountPercent;
}

export function getPricePlaceholder(
  selectedOption: UpgradeCycleModalOption | undefined,
  activationFallback: string | null,
): string {
  const fromOption = selectedOption?.formattedPrice;
  if (fromOption != null && fromOption !== '') {
    return fromOption;
  }
  if (activationFallback != null && activationFallback !== '') {
    return activationFallback;
  }
  return '...';
}

export function getActivationPriceFallback(props: UpgradeCycleModalProps): string | null {
  if (props.variant !== 'activation') {
    return null;
  }
  return props.content.ctaPriceFallback;
}

export function getCycleKeyForConfirm(
  selectedOption: UpgradeCycleModalOption | undefined,
): GatorProtectProBillingCycle {
  if (selectedOption != null) {
    return selectedOption.cycleKey;
  }
  return DEFAULT_CONFIRM_CYCLE;
}

export function getCtaLabelDisplayText(
  props: UpgradeCycleModalProps,
  cycleKeyForCopy: GatorProtectProBillingCycle,
  pricePlaceholder: string,
): string {
  if (props.variant === 'activation') {
    const { staticCtaLabel, getCtaLabel } = props.content;
    if (staticCtaLabel != null && staticCtaLabel !== '') {
      return staticCtaLabel;
    }
    return getCtaLabel(cycleKeyForCopy, pricePlaceholder);
  }
  return props.content.getCtaLabel(cycleKeyForCopy, pricePlaceholder);
}
